/* eslint-disable import/order */

import React, { FC } from 'react';
import { isLoggedInWithUaePass } from '~/utils/getDecodedJwt';
import NonUaePassSignContract from './NonUaePassSignContract';
import UaePassSignContract from './UaePassSignContract';

const SignContract: FC = () => {
  return <>{isLoggedInWithUaePass() ? <UaePassSignContract /> : <NonUaePassSignContract />}</>;
};

export default SignContract;
